/**
 * referrals (紹介者重複チェック) の公開ルート定義
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const REFERRALS_PUBLIC_PATHS = {
  pages: [] as const,
  apis: ['/api/referrals/check-email'] as const,
} as const
